import React, { useState, useEffect } from 'react';

import useAuthAdmin from '../hooks/useAuthAdmin';
import useSetPageTitle from '../../hooks/useSetPageTitle';

import EmailTable from '../components/EmailTable/EmailTable';
import PopupAddress from '../components/PopupAddress/PopupAddress';

import LinearLoader from "../../components/Loader/LinearLoader";

import SearchBar from '../../components/TextInput/SearchBar';

import './styles.css';

function EmailChangeRequests() {

    useAuthAdmin();
    useSetPageTitle('Admin');

    const [popupAddress, setPopupAddress] = useState(false);
    const [address, setAddress] = useState({});

    const [loadingExport] = useState(false);
    const [errorExport] = useState('');

    const [search, setSearch] = useState('');
    const [query, setQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);

    const handleSearch = (search) => {
        setSearch(search);
    }

    const executeSearch = () => {
        setQuery(search);
        setCurrentPage(1); // Reset to first page on new search
    }

    useEffect(() => {
        if (search.trim() === '') {
            setQuery('');
            setCurrentPage(1);
        }
    }, [search]);

    return (
        <>
            { popupAddress ? <PopupAddress setPopup={setPopupAddress} address={address} /> : false }
            <div className="admin-page-container">
                <div className="admin-page-title-container">
                    <p className="admin-page-title">Trocas de e-mail</p>
                    <p className="admin-page-error-import">{errorExport}</p>
                </div>
                <div className="admin-page-select-input-container">
                    <SearchBar setValue={handleSearch} rubik />
                    <button onClick={executeSearch} className="search-button">Buscar</button>
                    { loadingExport ? <LinearLoader /> : false }
                </div>
                <div style={{ marginBottom: '32px' }} />
                <EmailTable 
                    search={query} 
                    currentPage={currentPage} 
                    setCurrentPage={setCurrentPage} 
                    setPopup={setPopupAddress} 
                    setAddress={setAddress} 
                />
            </div>
        </>
    )
}

export default EmailChangeRequests;
